import { render, staticRenderFns } from "./FileReader.vue?vue&type=template&id=246ac3d8&scoped=true"
import script from "./FileReader.vue?vue&type=script&lang=js"
export * from "./FileReader.vue?vue&type=script&lang=js"
import style0 from "./FileReader.vue?vue&type=style&index=0&id=246ac3d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246ac3d8",
  null
  
)

export default component.exports